<template lang="pug">
div.animated.fadeIn
  b-card
    div.row.p-0
      b-img(src='static/img/analytics.jpeg' alt='Users & Interactions Graph' style='height: 100%; width: 100%;')
  //- iframe.chatflow(src='https://www.chatbase.com/overview?botKey=005f4c4c-e61a-4cd6-b60b-f23424881c79&platform=__any__&version=__any__&period=1&cohortsPeriod=6week')
</template>

<script>
export default {
  name: 'dashboard',
  data() {
    return {
    }
  },
  mounted: function() {
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Graph.vue?0d32faee